/**
 * Page-one data the server inlined into the SPA shell as UI8.preload
 * (app/routes.js renderSpa, perf phase 2): the signed-in user, the home
 * digest, category page one, or a profile. Each key is handed out once,
 * and only while the page is still the one the server rendered, so
 * in-app navigation and later refreshes hit the API exactly as before.
 */
angular.module("UI8.services").service("PreloadService", [
  "$window",
  function ($window) {
    function store() {
      var preload = $window.UI8 && $window.UI8.preload;
      if (!preload || preload.path !== $window.location.pathname) return null;
      return preload;
    }

    // Read without consuming (for a second consumer of the same key)
    this.peek = function (key) {
      var preload = store();
      return preload && preload[key] != null ? preload[key] : null;
    };

    // Read and consume
    this.take = function (key) {
      var preload = store();
      if (!preload || preload[key] == null) return null;
      var value = preload[key];
      delete preload[key];
      return value;
    };
  },
]);
